import ImsObjectCollection from 'app/shared/collections/ims_object_collection.service';
import { Tag } from 'app/shared/collections/tag';
import { flatten, keyBy } from 'lodash';

/**
 * Turns a collection of IMS Object with a tags property into a single object of tags keyed by their id
 */
export function getUniqueTags(collection: ImsObjectCollection): { [id: number]: Tag } {
    const tags = flatten<Tag>(
        Object.values(collection.all).map((imsObject) => Object.values(imsObject.tags || {})),
    );
    return keyBy<Tag>(tags, 'id');
}
